import React, { useState, useCallback, memo, useContext } from 'react';
import PropTypes from 'prop-types';

import 'react-contexify/dist/ReactContexify.css';
import { useClipboard } from 'use-clipboard-copy';

import { DashboardOverrideDialog } from 'components/Widget/components/menus/DashboardContextMenu';
import { formatDashboardContextMenuRequestParams } from 'utils/widget-helpers';
import useNavigate from 'hooks/useNavigate';
import useApi, { UPDATE_USER_ROUTE } from 'hooks/useApi';
import UserSessionContext from 'context/UserSessionContext';
import * as ACTIONS from 'context/actions';
import { TableContextMenu, TabsContextMenu } from './components';

const ContextMenu = memo(({ isDefaultTemplate, dispatchCannedDashboardList, dashboardsCount }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [dashboardMenuProps, setDashboardMenuProps] = useState();
  const clipboard = useClipboard();
  const { dispatch } = useContext(UserSessionContext);
  const navigate = useNavigate();

  const [, sendRequest] = useApi();

  const handleItemClick = useCallback(({ props, data }) => {
    const formatRequestParams = formatDashboardContextMenuRequestParams({
      props,
      data
    });

    setDashboardMenuProps({ ...formatRequestParams });
    setIsOpen(true);
  }, []);

  const handleAnchorItemClick = useCallback(
    ({ props: { tabHref } }) => {
      navigate(tabHref, '_blank');
    },
    [navigate]
  );

  const handleCopyItemClick = useCallback(
    ({ props: { tabHref } }) => {
      clipboard.copy(tabHref);
    },
    [clipboard]
  );

  const handleSetHomepageClick = useCallback(
    ({ props: { tabHref } }) => {
      sendRequest(UPDATE_USER_ROUTE(tabHref.substring(tabHref.indexOf('/canned'))));
      dispatch({ type: ACTIONS.UPDATE_USER_HOMEPAGE_PREFERENCE, payload: tabHref.substring(tabHref.indexOf('/canned')) });
    },
    [dispatch, sendRequest]
  );

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <>
      <TabsContextMenu
        handleItemClick={handleItemClick}
        isDefaultTemplate={isDefaultTemplate}
        handleAnchorItemClick={handleAnchorItemClick}
        handleCopyItemClick={handleCopyItemClick}
        handleSetHomepageClick={handleSetHomepageClick}
      />

      <TableContextMenu
        handleAnchorItemClick={handleAnchorItemClick}
        handleCopyItemClick={handleCopyItemClick}
      />

      {isOpen && (
        <DashboardOverrideDialog
          isOpen={isOpen}
          handleClose={handleClose}
          dashboardMenuProps={dashboardMenuProps}
          dispatchCannedDashboardList={dispatchCannedDashboardList}
          dashboardsCount={dashboardsCount}
        />
      )}
    </>
  );
});

ContextMenu.propTypes = {
  isDefaultTemplate: PropTypes.bool.isRequired,
  dispatchCannedDashboardList: PropTypes.func.isRequired,
  dashboardsCount: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]).isRequired
};

export default ContextMenu;
